import Vue from 'vue'
// window.$ = window.jQuery = require('jquery')
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store/store'

import './moment'
import { i18n } from './i18n'
import './vee-validate'
import './intl-tel-input'
import './loader'


Vue.use(VueRouter)
Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.API_URL;

import App from './App.vue'
import FormStep1 from './FormStep1.vue'
import FormStep2 from './FormStep2.vue'
import FormStep3 from './FormStep3.vue'
import Offers from './Offers.vue'
import Summary from './Summary.vue'
import PolicyFinish from './PolicyFinish.vue'

const router = new VueRouter({
  mode: 'abstract',
  hash: false,
  routes: [
    {
      path: '/',
      name: 'form-step-1',
      component: FormStep1
    },
    {
      path: '/form-step-2',
      name: 'form-step-2',
      component: FormStep2
    },
    {
      path: '/form-step-3',
      name: 'form-step-3',
      component: FormStep3
    },
    {
      path: '/offers',
      name: 'offers',
      component: Offers
    },
    {
      path: '/summary',
      name: 'summary',
      component: Summary
    },
    {
      path: '/policy-finish',
      name: 'policy-finish',
      component: PolicyFinish
    }
  ]
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(App),
  store
})
